import type { FC } from 'react';

// TODO: Add page content is follow up PR.
const WebhooksTab: FC = () => <div />;

export default WebhooksTab;
